export const URL_API = process.env.REACT_APP_BASE_URL;

export const detailCustomer = {
  getCustomerId: (id: string) => `${URL_API}/account/profil-shared/${id}`,
};
